import PropTypes from 'prop-types';

export const Icons = ({ className = '', variant, onClick = () => {} }) => {
  const renderIcon = () => {
    switch (variant) {
      case Icons.INFO:
        return (
          <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.583333"
              y="0.583333"
              width="26.8333"
              height="26.8333"
              rx="8.75"
              fill="white"
            />
            <rect
              x="0.583333"
              y="0.583333"
              width="26.8333"
              height="26.8333"
              rx="8.75"
              stroke="url(#paint0_linear_74889_32586)"
              strokeWidth="1.16667"
            />
            <g clipPath="url(#clip0_74889_32586)">
              <path
                d="M12.9481 16.4505V16.3212C12.9514 15.7213 13.0078 15.244 13.1171 14.8894C13.2298 14.5347 13.3889 14.2497 13.5944 14.0343C13.7999 13.8155 14.0501 13.615 14.3451 13.4327C14.5473 13.3068 14.7279 13.1692 14.887 13.0201C15.0494 12.8676 15.177 12.6986 15.2698 12.513C15.3626 12.324 15.409 12.1136 15.409 11.8816C15.409 11.6197 15.3477 11.3927 15.2251 11.2005C15.1025 11.0082 14.9367 10.8591 14.7279 10.753C14.5224 10.647 14.2921 10.5939 14.0369 10.5939C13.8016 10.5939 13.5778 10.6453 13.3657 10.748C13.1569 10.8475 12.9829 10.9999 12.8437 11.2054C12.7078 11.4076 12.6316 11.6645 12.615 11.976H10.8451C10.8617 11.3463 11.0142 10.8193 11.3025 10.3951C11.5942 9.97082 11.9786 9.65264 12.4559 9.44052C12.9365 9.2284 13.4668 9.12234 14.0468 9.12234C14.6799 9.12234 15.2367 9.23337 15.7173 9.45543C16.2012 9.6775 16.5774 9.99402 16.8458 10.405C17.1176 10.8127 17.2535 11.2966 17.2535 11.8567C17.2535 12.2346 17.1922 12.5726 17.0696 12.8709C16.9502 13.1692 16.7795 13.4344 16.5575 13.6664C16.3354 13.8984 16.0719 14.1055 15.767 14.2878C15.4985 14.4535 15.2781 14.6259 15.1058 14.8049C14.9367 14.9838 14.8108 15.1943 14.7279 15.4363C14.6484 15.6749 14.607 15.9699 14.6036 16.3212V16.4505H12.9481ZM13.8132 19.5527C13.5149 19.5527 13.258 19.4467 13.0426 19.2346C12.8271 19.0224 12.7194 18.7639 12.7194 18.459C12.7194 18.1607 12.8271 17.9055 13.0426 17.6934C13.258 17.4812 13.5149 17.3752 13.8132 17.3752C14.1081 17.3752 14.3634 17.4812 14.5788 17.6934C14.7975 17.9055 14.9069 18.1607 14.9069 18.459C14.9069 18.6612 14.8555 18.8451 14.7528 19.0108C14.6534 19.1766 14.5208 19.3091 14.3551 19.4086C14.1927 19.5047 14.012 19.5527 13.8132 19.5527Z"
                fill="#262626"
              />
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_74889_32586"
                x1="8.07692"
                y1="8.61538"
                x2="39.8462"
                y2="35"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FF576D" />
                <stop offset="1" stopColor="#FB913A" />
              </linearGradient>
              <clipPath id="clip0_74889_32586">
                <rect
                  width="15.5556"
                  height="15.5556"
                  fill="white"
                  transform="translate(6.22266 6.22266)"
                />
              </clipPath>
            </defs>
          </svg>
        );
      case Icons.GREEN_CHECKMARK:
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" fill="#04A451" />
            <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="white" />
            <g clipPath="url(#clip0_75419_478559)">
              <path
                d="M7.33252 12.0013L10.6659 15.3346L17.3325 8.66797"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_75419_478559">
                <rect width="16" height="16" fill="white" transform="translate(4 4)" />
              </clipPath>
            </defs>
          </svg>
        );
      case Icons.ADD_MLS:
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="24" height="24" rx="12" fill="#FF576D" />
            <rect width="16" height="16" transform="translate(4 4)" fill="#FF576D" />
            <path d="M7 12H17" stroke="white" strokeWidth="2" strokeLinecap="round" />
            <path d="M12 17L12 7" stroke="white" strokeWidth="2" strokeLinecap="round" />
          </svg>
        );

      default:
        return null;
    }
  };
  return (
    <div onClick={onClick} className={className} style={{ display: 'flex' }}>
      {renderIcon()}
    </div>
  );
};

Icons.INFO = 'Info';
Icons.GREEN_CHECKMARK = 'greenCheckmark';
Icons.ADD_MLS = 'addMls';
